import classNames from 'classnames';
import { ComponentProps } from 'react';
import { FormattedNumber } from 'react-intl';
import { useQuote } from 'routes/essential-workspace/hooks/use-quote';
import { useQuotePriceInfo } from 'routes/essential-workspace/hooks/use-quote-price-info';

export function QuotePriceText({ className, ...props }: ComponentProps<'h4'>) {
  const { formId, textColor } = useQuote();
  const { format, isStrikethrough, price } = useQuotePriceInfo(formId);

  if (price === undefined) {
    return null;
  }

  return (
    <h4
      {...props}
      className={classNames(
        'fw-medium monospace-numbers m-0',
        textColor,
        {
          'text-decoration-line-through': isStrikethrough,
        },
        className,
      )}
    >
      <FormattedNumber value={price} maximumFractionDigits={4} style={format} />
    </h4>
  );
}
